import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    this.open = false
    this.boundClickOutside = this.clickOutside.bind(this)
  }

  toggle() {
    this.open = !this.open

    if (this.open) {
      this.showMenu()
    } else {
      this.hideMenu()
    }
  }

  showMenu() {
    this.menuTarget.classList.remove("hidden")
    this.menuTarget.classList.add("animate-fade-in")
    document.addEventListener("click", this.boundClickOutside)

    // Update button aria attributes
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "true")
    }
  }

  hideMenu() {
    this.menuTarget.classList.add("hidden")
    this.menuTarget.classList.remove("animate-fade-in")
    document.removeEventListener("click", this.boundClickOutside)

    // Update button aria attributes
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideMenu()
      this.open = false
    }
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
  }
}